import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getAllPlaces, getRefuncdPolicy } from "../../redux/actions/indexActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CKEditor from "react-ckeditor-component";


const RefundPolicy = () => {
  const [formData, setFormData] = useState({ place_id: "", status: 0, });
  const [text, setText] = useState([]);
  const [errors, setErrors] = useState({});
  const { AuthReducer: { auth }, indexReducer: { places } } = useSelector((state) => state);
  const { indexReducer: { RefundPolicy } } = useSelector((state) => state);
  console.log(RefundPolicy, 'refundPolicy')
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // console.log(places, 'places')
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else { setFormData({ ...formData, [name]: value }); }
  };

  useEffect(() => {
    if (auth?.token) {
      dispatch(getRefuncdPolicy(auth.token));
    }
  }
    , [auth]);
  useEffect(() => {
    dispatch(getAllPlaces(auth.token));
  }, [auth]);

  const handleText = (e) => {
    const descriptions = e.editor.getData();
    setText(descriptions);
  }

  const handleSubmit = () => {
    const form = new FormData();
    form.append('place_id', formData.place_id);
    form.append('description', text);
    form.append('status', formData.status);
    axios.post(`/api/admin/v1/add-refund-policy`, form, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    }).then((res) => {
      toast.success(res.data?.message);
      navigate(-1);
    }).catch((err) => {
      toast.error(err.response.data);
      setErrors(err.response.data);
    });
  };
  const onDelete = (id) => {
    if (window.confirm("Are You Sure You Want To Delete !")) {
      axios.delete(`/api/admin/v1/refund-policy-delete/${id}`, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      }).then((res) => {
        toast.success(res.data.message);
        dispatch(getRefuncdPolicy(auth.token));
      }).catch((err) => toast.error("Somthing Went Wrong"));
    }
  };
  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Refund Policy</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Place <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.place_id}
                type="select"
                name="place_id"
                onChange={inputHandler}
              >
                <option value="">Select Place</option>
                {places?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.place_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.place_id}</span>

            </FormGroup>
          </div>
          <div className="col-md-9 offset-md-1">
            <FormGroup>
              <Label>Refund Policy</Label>
              <CKEditor content={text} events={{ "change": handleText }} />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
          <div className="col-md-12 mt-3">
            <span className="text-danger">{errors?.description}</span>
          </div>
          <div className="container mt-3">
            <div className="row">
              <div className="col-md-12">
                {RefundPolicy?.map((item, index) => (
                  <div className="card mb-3 shadow-sm border-0" key={index}>
                    <div className="card-body d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="card-title text-primary">{item?.place?.place_name}  <button className="btn btn-danger btn-sm" onClick={() => onDelete(item?.id)}>
                          <i className="fas fa-trash"></i> Delete
                        </button></h5>
                        <p className="card-text text-muted" dangerouslySetInnerHTML={{ __html: item?.description }}></p>
                        <span className={`badge ${item?.status === 1 ? "bg-success" : "bg-danger"}`}>
                          {item?.status === 1 ? "Active" : "Inactive"}
                        </span>
                      </div>

                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
